<template>
	<div>
		<div v-click-outside="onClose" class="dropdown-wrapper">
			<div @click="expanded = ! expanded"
				 class="button">
				<template v-if="!! view">
					<i :class="view.icon" />
					<span>{{ view.label }}</span>
				</template>

				<i class="far fa-chevron-down fa-fw" />
			</div>

			<div v-if="expanded"
				 class="views">
				<div v-for="key in Object.keys(views)"
					 :key="`view-${key}`"
					 @click="onChange(key)"
					 class="view">
					<i :class="views[key].icon" />
					<span>{{ views[key].label }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

import datepickerMixin from '@/app/datepicker/datepicker.mixin'
import FacebookService from "@/services/_app/meta/FacebookService";

export default {
	directives: {
		ClickOutside
	},

	mixins: [
		datepickerMixin
	],

	props: {
		value: {},

		viewRequirements: {
			type: Object,
			required: true
		}
	},

	data: () => ({
		expanded: false,
		values: {},
	}),

	computed: {
		views() {
			const views = {
				default: {
					icon: 'far fa-list fa-fw',
					label: this.$t('google.ads.views.default')
				},

				efficiency: {
					icon: 'far fa-mouse-pointer fa-fw',
					label: this.$t('google.ads.views.efficiency')
				},

				video: {
					icon: 'far fa-video fa-fw',
					label: this.$t('google.ads.views.video')
				},

				display: {
					icon: 'far fa-desktop fa-fw',
					label: this.$t('google.ads.views.display')
				},

				ecommerce: {
					icon: 'far fa-shopping-cart fa-fw',
					label: this.$t('google.ads.views.ecommerce')
				},

				conversions: {
					icon: 'far fa-exchange fa-fw',
					label: this.$t('google.ads.views.conversions')
				},

				competition: {
					icon: 'far fa-users fa-fw',
					label: this.$t('google.ads.views.competition')
				}
			}

			return views
		},

		view() {
			return this.views[this.internalValue]
		},

		internalValue: {
			get() {
				return this.value
			},

			set(value) {
				this.$emit('input', value)
			}
		}
	},

	watch: {
		from() {
			this.onLoad()
		}
	},

	mounted() {
		this.onLoad()
	},

	methods: {
		onLoad() {
			return new Promise((resolve) => {
				// @TOOD: Load conversions
				resolve()
			})
		},

		onChange(value) {
			this.internalValue = value
			this.onClose()
		},

		onClose() {
			this.expanded = false
		}
	}
}
</script>

<style lang="scss" scoped>
.dropdown-wrapper {
	position: relative;

	> div.button {
		cursor: pointer;
		user-select: none;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		gap: 10px;
		padding: 0 10px;
		color: #000;
		font-size: 14px;
		font-weight: 500;
		border: 1px solid #ccc;
		border-radius: 6px;
		height: 36px;
	}

	> div.views {
		position: absolute;
		top: 100%;
		right: 0;
		min-width: 200px;
		border: 1px solid #ccc;
		border-radius: 6px;
		background-color: #fff;
		margin-top: 10px;
		z-index: 99;

		> div.view {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			gap: 10px;
			color: #000;
			font-size: 14px;
			font-weight: 400;
			padding: 10px 15px;
			border-bottom: 1px solid #eee;

			&:hover {
				cursor: pointer;
				user-select: none;
				background-color: #eee;
			}
		}
	}
}
</style>
